import { isVisibaIOSApp, getCookie } from '@visiba/std';

// Source: https://github.com/atomantic/is-ua-webview/blob/9b9e8fa0abaaec892752ffe4229431293df3c388/data/rules.js
const navigatorRules = [
	// if it says it's a webview, let's go with that
	'WebView',
	// iOS webview will be the same as safari but missing "Safari"
	'(iPhone|iPod|iPad)(?!.*Safari)',
	// Android Lollipop and Above: webview will be the same as native but it will contain "wv"
	// Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
	'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
	// old chrome android webview agent
	'Linux; U; Android',
] as const;
const webviewRegExp = new RegExp('(' + navigatorRules.join('|') + ')', 'i');

export function isWithinVisibaWebView(): boolean {
	if (isVisibaIOSApp()) return true;
	if (isVisibaAndroidApp()) return true;
	// Source: https://github.com/atomantic/is-ua-webview/blob/9b9e8fa0abaaec892752ffe4229431293df3c388/index.js
	if (navigator.userAgent.match(webviewRegExp)) return true;

	return false;
}

// todo: Move to Cortex.s
function isVisibaAndroidApp(): boolean {
	try {
		const cookie = getCookie('VisibaAndroidApp');

		return !!cookie;
	} catch {
		return false;
	}
}
